import React, { useEffect, useState } from 'react';
import SectionPhq9 from './SectionPhq9';
import { api, DEMO } from '../lib/api';

// Registry is fetched server-side in API mode; PHQ-9 is the seeded instrument.
const DEMO_INSTRUMENTS = [
  { id: 'phq9', name: 'PHQ-9 Depression Screening', kind: 'clinical', description: 'Nine-item Patient Health Questionnaire; score 0–27.' },
];

// Reusable assessments section: lists registered instruments and dispatches each to its renderer.
// PHQ-9 keeps its dedicated component (authoritative store); future instruments render generically.
export default function SectionClinicalAssessments({ patient, user, afterChange, notify, logDemo, updateDemoPatient, openSafety }) {
  const [instruments, setInstruments] = useState(DEMO ? DEMO_INSTRUMENTS : []);
  const [activeId, setActiveId] = useState('phq9');

  useEffect(() => {
    if (DEMO) return;
    api('/assessment-instruments').then(d => setInstruments(d.instruments || [])).catch(e => notify(e.message));
  }, []);

  const active = instruments.find(i => i.id === activeId);

  return (
    <div>
      {instruments.length > 1 && (
        <div className="assess-nav">
          {instruments.map(i => (
            <button key={i.id} className={`assess-nav-item ${i.id === activeId ? 'selected' : ''}`} onClick={() => setActiveId(i.id)}>{i.name}</button>
          ))}
        </div>
      )}
      {activeId === 'phq9' && <SectionPhq9 patient={patient} user={user} afterChange={afterChange} notify={notify} logDemo={logDemo} updateDemoPatient={updateDemoPatient} openSafety={openSafety}/>}
      {activeId !== 'phq9' && active && <AssessmentResultsCard patient={patient} instrument={active} notify={notify}/>}
    </div>
  );
}

// Generic read-only result list for instruments stored in assessment_results.
function AssessmentResultsCard({ patient, instrument, notify }) {
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (DEMO) { setResults((patient.assessment_results || []).filter(r => r.instrument_id === instrument.id)); return; }
    api(`/patients/${patient.id}/assessments/${instrument.id}`).then(d => setResults(d.results || [])).catch(e => notify(e.message));
  }, [patient.id, instrument.id]);

  return (
    <section className="content-card">
      <div className="content-heading">
        <div><h3>{instrument.name}</h3><p>{instrument.description || 'Structured assessment result.'}</p></div>
      </div>
      <div className="table-scroll">
        <table>
          <thead><tr><th>Completed</th><th>Severity</th><th>Scores</th><th>By</th></tr></thead>
          <tbody>
            {results.map(r => (
              <tr key={r.id}>
                <td>{new Date(r.completed_at).toLocaleString()}</td>
                <td>{r.severity || '—'}</td>
                <td>{r.scores ? JSON.stringify(r.scores) : '—'}</td>
                <td>{r.completed_by_name || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!results.length && <p className="empty-copy">No results recorded for this assessment.</p>}
      </div>
    </section>
  );
}
